import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import Constant from "constants";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/agate";
import Select from "react-select";

import "./index.css";
import api from "api";
import { SelectOption, ApiResponse } from "model/response";
import { DatasourceListingResponse, DataSource } from "model/datasource";
import {
  ScheduleQuery,
  ScheduleQueryDetailResponse,
} from "model/schedule_query";
import { Popup } from "components/Popup";

interface ModalData {
  isOpen: boolean;
  title: string;
  type: string;
  description: string;
  onPressSubmit: Function;
  onPressCancel: Function;
}

const ScheduleTimeOpstions: Array<SelectOption> = [
  // {
  //   label: "every 15 minutes",
  //   value: "every 15 minutes",
  // },
  // {
  //   label: "every 30 minutes",
  //   value: "every 30 minutes",
  // },
  {
    label: "monthly",
    value: "monthly",
  },
  {
    label: "weekly",
    value: "weekly",
  },
  {
    label: "every day",
    value: "every day",
  },
  {
    label: "every 12 hours",
    value: "every 12 hours",
  },
  {
    label: "every 8 hours",
    value: "every 8 hours",
  },
  {
    label: "every 6 hours",
    value: "every 6 hours",
  },
  {
    label: "every 5 hours",
    value: "every 5 hours",
  },
  {
    label: "every 4 hours",
    value: "every 4 hours",
  },
  {
    label: "every 3 hours",
    value: "every 3 hours",
  },
  {
    label: "every 2 hours",
    value: "every 2 hours",
  },
  {
    label: "every 1 hours",
    value: "every 1 hours",
  },
];

const WeekdayOpstions: Array<SelectOption> = [
  {
    label: "monday",
    value: "monday",
  },
  {
    label: "tuesday",
    value: "tuesday",
  },
  {
    label: "wednesday",
    value: "wednesday",
  },
  {
    label: "thursday",
    value: "thursday",
  },
  {
    label: "friday",
    value: "friday",
  },
  {
    label: "saturday",
    value: "saturday",
  },
  {
    label: "sunday",
    value: "sunday",
  },
];

export default function ScheduleQueryEdit(props: any) {
  const match = useRouteMatch("/schedule_query/:schedule_query_id");
  const params: any = match?.params;
  const scheduleQueryId = params?.schedule_query_id;
  const [loading, setLoading] = useState(true);

  const isEdit = scheduleQueryId ? true : false;
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<any>({});
  const [datasourceOptions, setDatasourceOptions] = useState<
    Array<SelectOption>
  >([]);
  // Schedule Query Data
  const [selectedDatasource, setSelectedDatasource] =
    useState<SelectOption | null>(null);
  const [selectedWeekday, setSelectedWeekday] = useState<SelectOption | null>(
    null
  );
  const [selectedScheduleTime, setSelectedScheduleTime] =
    useState<SelectOption | null>(null);
  const [time, setTime] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const [isAppend, setIsAppend] = useState<boolean>(false);
  const [scheduleQueryData, setScheduleQueryData] = useState<ScheduleQuery>({
    name: "",
    dataset_name: "",
    datasource_id: 0,
    description: "",
    query: "",
    schedule_time: "",
    table_name: "",
    write_disposition: isAppend ? "WRITE_APPEND" : "WRITE_TRUNCATE",
  });

  const [modalData, setModalData] = useState<ModalData>({
    isOpen: false,
    title: "",
    type: "error",
    description: "",
    onPressCancel: () => {},
    onPressSubmit: () => {},
  });

  useEffect(() => {
    initData();
  }, []);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    const res: ApiResponse = await ApiCaller.get(
      `datasource?is_active=1&company_id=${companyId}&include_types=google_bigquery`
    );
    if (res?.status === "ok") {
      const data: DatasourceListingResponse = res?.data;
      setDatasourceOptions(
        data?.datasources?.map((datasource) => {
          return {
            label: `${datasource?.name} - ${datasource?.project}`,
            value: datasource.id,
          };
        })
      );
      if (isEdit) {
        const resScheduleQueryDetail: ApiResponse = await ApiCaller.get(
          `schedule_query/${scheduleQueryId}`
        );
        if (resScheduleQueryDetail?.status === "ok") {
          const dataScheduleQueryDetail: ScheduleQueryDetailResponse =
            resScheduleQueryDetail?.data;
          // Find datasource
          const findDatasource: any = data?.datasources.find(
            (datasource) =>
              datasource.id ==
              dataScheduleQueryDetail?.schedule_query?.datasource_id
          );
          setSelectedDatasource({
            label: `${findDatasource?.name} - ${findDatasource?.project}`,
            value: findDatasource?.id,
          });
          // Find schedule time
          if (
            checkingDailyScheduleTime(
              dataScheduleQueryDetail?.schedule_query?.schedule_time
            )
          ) {
            if (
              checkingMonthlyScheduleTime(
                dataScheduleQueryDetail?.schedule_query?.schedule_time
              )
            ) {
              const scheduleTimeList =
                dataScheduleQueryDetail?.schedule_query?.schedule_time.split(
                  " "
                );
              const scheduleTime = "monthly";
              const date = `${scheduleTimeList[0]}`;
              const time = `${scheduleTimeList[3]}`;
              const findScheduleTime: any = ScheduleTimeOpstions.find(
                (options) => options.value == scheduleTime
              );
              setSelectedScheduleTime(findScheduleTime);
              setTime(time);
              setDate(date);
            } else if (
              checkingWeeklyScheduleTime(
                dataScheduleQueryDetail?.schedule_query?.schedule_time
              )
            ) {
              const scheduleTimeList =
                dataScheduleQueryDetail?.schedule_query?.schedule_time.split(
                  " "
                );
              const scheduleTime = "weekly";
              const weekday = `${scheduleTimeList[1]}`;
              const time = `${scheduleTimeList[2]}`;
              const findScheduleTime: any = ScheduleTimeOpstions.find(
                (options) => options.value == scheduleTime
              );
              const findWeekday: any = WeekdayOpstions.find(
                (options) => options.value == weekday
              );
              setSelectedScheduleTime(findScheduleTime);
              setSelectedWeekday(findWeekday);
              setTime(time);
            } else {
              const scheduleTimeList =
                dataScheduleQueryDetail?.schedule_query?.schedule_time.split(
                  " "
                );
              const scheduleTime = `${scheduleTimeList[0]} ${scheduleTimeList[1]}`;
              const time = `${scheduleTimeList[2]}`;
              const findScheduleTime: any = ScheduleTimeOpstions.find(
                (options) => options.value == scheduleTime
              );
              setSelectedScheduleTime(findScheduleTime);
              setTime(time);
            }
          } else {
            const findScheduleTime: any = ScheduleTimeOpstions.find(
              (options) =>
                options.value ==
                dataScheduleQueryDetail?.schedule_query?.schedule_time
            );
            setSelectedScheduleTime(findScheduleTime);
          }
          // Find append value
          setIsAppend(
            dataScheduleQueryDetail?.schedule_query?.write_disposition ===
              "WRITE_APPEND"
          );
          // Set schdule query data
          setScheduleQueryData({
            name: dataScheduleQueryDetail?.schedule_query?.name,
            dataset_name: dataScheduleQueryDetail?.schedule_query?.dataset_name,
            datasource_id:
              dataScheduleQueryDetail?.schedule_query?.datasource_id,
            description: dataScheduleQueryDetail?.schedule_query?.description,
            query: dataScheduleQueryDetail?.schedule_query?.query,
            schedule_time:
              dataScheduleQueryDetail?.schedule_query?.schedule_time,
            table_name: dataScheduleQueryDetail?.schedule_query?.table_name,
            write_disposition:
              dataScheduleQueryDetail?.schedule_query?.write_disposition,
          });
        }
      }
    }
    setLoading(false);
  };

  const onSubmit = async () => {
    const {
      name,
      description,
      dataset_name,
      table_name,
      query,
      schedule_time,
      write_disposition,
    } = scheduleQueryData;
    if (
      name === "" ||
      description === "" ||
      dataset_name === "" ||
      table_name === "" ||
      query === "" ||
      schedule_time === "" ||
      write_disposition === ""
    ) {
      setModalData({
        isOpen: true,
        title: "Error",
        type: "error",
        description: "Missing required fields",
        onPressSubmit: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
        onPressCancel: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
      });
      return;
    }
    // console.log(scheduleQueryData.schedule_time);
    setLoading(true);
    if (isEdit) {
      // Set schedule id to update
      const res: ApiResponse = await ApiCaller.put(
        `schedule_query/${scheduleQueryId}`,
        scheduleQueryData
      );
      if (res?.status === "ok") {
        props.history.goBack();
        // window.location.href = `/schedule_query/${scheduleQueryId}/`;
      } else {
        setLoading(false);
        setModalData({
          isOpen: true,
          title: "Error",
          type: "error",
          description: res?.message,
          onPressSubmit: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
          onPressCancel: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
        });
      }
    } else {
      const res: ApiResponse = await ApiCaller.post(
        `schedule_query`,
        scheduleQueryData
      );
      if (res?.status === "ok") {
        props.history.goBack();
      } else {
        setLoading(false);
        setModalData({
          isOpen: true,
          title: "Error",
          type: "error",
          description: res?.message,
          onPressSubmit: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
          onPressCancel: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
        });
      }
    }
  };

  const checkingDailyScheduleTime = (schedule_time: string) => {
    if (!schedule_time) return false;
    if (
      schedule_time.includes("day") ||
      schedule_time.includes("week") ||
      schedule_time.includes("month")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkingMonthlyScheduleTime = (schedule_time: string) => {
    if (!schedule_time) return false;
    if (
      schedule_time.includes("of month") ||
      schedule_time.includes("monthly")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkingWeeklyScheduleTime = (schedule_time: string) => {
    console.log(schedule_time)
    return (
      WeekdayOpstions.some((el) => schedule_time?.includes(el.value) || schedule_time?.includes("weekly"))
    );
  };

  if (loading) return <Loading />;

  return (
    <Container>
      <Popup
        type={modalData?.type}
        isOpen={modalData?.isOpen}
        title={modalData?.title}
        description={modalData?.description}
        onPressSubmit={modalData?.onPressSubmit}
        onPressCancel={modalData?.onPressCancel}
      />
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label for="project"> Project </Label>
            <Select
              placeholder=""
              options={datasourceOptions}
              value={selectedDatasource}
              onChange={(selectedOption: any) => {
                setSelectedDatasource(selectedOption);
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{ datasource_id: selectedOption?.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Name (*)</Label>
            <Input
              type="text"
              value={scheduleQueryData?.name}
              onChange={(e) => {
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{ name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Description (*)</Label>
            <Input
              type="textarea"
              value={scheduleQueryData?.description}
              onChange={(e) => {
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{ description: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Destination Dataset Name (*)</Label>
            <Input
              type="text"
              value={scheduleQueryData?.dataset_name}
              onChange={(e) => {
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{ dataset_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Destination Table Name (*)</Label>
            <Input
              type="text"
              value={scheduleQueryData?.table_name}
              onChange={(e) => {
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{ table_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup tag="fieldset">
            <Label for="dataset">Destination table write preference (*)</Label>
            <FormGroup check>
              <Label check>
                <Input
                  checked={!isAppend}
                  type="radio"
                  onChange={(e) => {
                    setIsAppend(false);
                    setScheduleQueryData({
                      ...scheduleQueryData,
                      ...{ write_disposition: "WRITE_TRUNCATE" },
                    });
                  }}
                />{" "}
                Overwrite table
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label>
                <Input
                  checked={isAppend}
                  type="radio"
                  onChange={(e) => {
                    setIsAppend(true);
                    setScheduleQueryData({
                      ...scheduleQueryData,
                      ...{ write_disposition: "WRITE_APPEND" },
                    });
                  }}
                />{" "}
                Append to table
              </Label>
            </FormGroup>
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label for="project"> Run schedule (*)</Label>
            <Select
              placeholder=""
              options={ScheduleTimeOpstions}
              value={selectedScheduleTime}
              onChange={(selectedOption: any) => {
                setSelectedScheduleTime(selectedOption);
                const newScheduleTime =
                  selectedOption?.value == "weekly"
                    ? "every"
                    : selectedOption?.value == "monthly"
                    ? "of month"
                    : selectedOption?.value;
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{
                    schedule_time: newScheduleTime,
                  },
                });
                // if (!checkingDailyScheduleTime(selectedOption?.value)) {
                setTime("");
                setDate("");
                setSelectedWeekday(null);
                // }
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          {checkingWeeklyScheduleTime(selectedScheduleTime?.value) && (
            <FormGroup>
              <Label for="project"> Weekday</Label>
              <Select
                placeholder=""
                options={WeekdayOpstions}
                value={selectedWeekday}
                onChange={(selectedOption: any) => {
                  setSelectedWeekday(selectedOption);
                  const newSelectedScheduleTime =
                    selectedScheduleTime?.value == "weekly"
                      ? "every"
                      : selectedScheduleTime?.value == "monthly"
                      ? "of month"
                      : selectedScheduleTime?.value;
                  const newScheduleTime = `${newSelectedScheduleTime} ${selectedOption.value} ${time}`;
                  setScheduleQueryData({
                    ...scheduleQueryData,
                    ...{ schedule_time: newScheduleTime },
                  });
                }}
              />
            </FormGroup>
          )}
        </Col>
        <Col xs={12}>
          {checkingMonthlyScheduleTime(selectedScheduleTime?.value) && (
            <FormGroup>
              <Label for="schedule_time">Date of month (from 1 to 31)</Label>
              <Input
                type="number"
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                  const newSelectedScheduleTime =
                    selectedScheduleTime?.value == "weekly"
                      ? "every"
                      : selectedScheduleTime?.value == "monthly"
                      ? "of month"
                      : selectedScheduleTime?.value;
                  const newScheduleTime = `${e.target.value} ${newSelectedScheduleTime} ${time}`;
                  setScheduleQueryData({
                    ...scheduleQueryData,
                    ...{ schedule_time: newScheduleTime },
                  });
                }}
              />
            </FormGroup>
          )}
        </Col>
        <Col xs={12}>
          {checkingDailyScheduleTime(selectedScheduleTime?.value) && (
            <FormGroup>
              <Label for="schedule_time">At Time</Label>
              <Input
                type="time"
                id="exampleTime"
                value={time}
                onChange={(e) => {
                  setTime(e.target.value);
                  const newSelectedScheduleTime =
                    selectedScheduleTime?.value == "weekly"
                      ? "every"
                      : selectedScheduleTime?.value == "monthly"
                      ? "of month"
                      : selectedScheduleTime?.value;
                  let newScheduleTime = `${newSelectedScheduleTime} ${e.target.value}`;
                  if (selectedWeekday) {
                    newScheduleTime = `${newSelectedScheduleTime} ${selectedWeekday?.value} ${e.target.value}`;
                  }
                  if (date) {
                    newScheduleTime = `${date} ${newScheduleTime}`;
                  }
                  setScheduleQueryData({
                    ...scheduleQueryData,
                    ...{ schedule_time: newScheduleTime },
                  });
                }}
              />
            </FormGroup>
          )}
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>SQL (*)</Label>
            <Input
              type="textarea"
              rows={4}
              value={scheduleQueryData?.query}
              onChange={(e) => {
                setScheduleQueryData({
                  ...scheduleQueryData,
                  ...{ query: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div style={styles.controls}>
            <Button color="primary" onClick={onSubmit}>
              {isEdit ? "Save changes" : "Create"}
            </Button>{" "}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  controls: {
    marginTop: 12,
    marginBottom: 12,
  },
  info: {
    marginTop: 12,
    marginBottom: 12,
  },
  infoHeading: {
    fontWeight: 700,
  },
  queryContainer: {
    marginTop: 12,
  },
};
